import { combineReducers } from "redux";
import quotes from "./quotes";

export default combineReducers({
  quotes,
});
